import React, { useState } from "react";

const TypedResponse = ({ Question, onResponse, documentType, isEdit }) => {
    const [inputValue, setInputValue] = useState("");
    const [isChatActive, setIsChatActive] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleInputChange = (event) => {
        let value = event.target.value;

        // ✅ Restrict Input Based on documentType
        if (documentType === "OTP") {
            value = value.replace(/[^0-9]/g, ""); // Only numbers
        } else if (documentType === "PAN" || documentType === "GST" || documentType === "Aadhar") {
            value = value.toUpperCase().replace(/[^A-Z0-9]/g, ""); // Only uppercase letters & numbers
        }

        setInputValue(value);
        setIsChatActive(!!value);
        setErrorMessage("");
    };

    const handleSubmit = () => {
        let isValid = true;
        let error = "";

        // ✅ Validate PAN Format (ABCDE1234F)
        if (documentType === "PAN" && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(inputValue)) {
            isValid = false;
            error = "❌ Invalid PAN format. Example: ABCDE1234F";
        }

        // ✅ Validate Aadhar Format (12 Digits)
        if (documentType === "Aadhar" && !/^\d{12}$/.test(inputValue)) {
            isValid = false;
            error = "❌ Aadhar must be exactly 12 digits.";
        }

        // ✅ Validate GST Number Format (27ABCDE1234F1Z5)
        if (documentType === "GST" && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}Z[0-9A-Z]{1}$/.test(inputValue)) {
            isValid = false;
            error = "❌ Invalid GST Number format. Example: 27ABCDE1234F1Z5";
        }

        // ✅ Validate OTP (5 Digits)
        if (documentType === "OTP" && !/^\d{5}$/.test(inputValue)) {
            isValid = false;
            error = "❌ OTP must be exactly 5 digits.";
        }

        if (
            (documentType === "COMP_PAN") &&
            !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(inputValue)
        ) {
            isValid = false;
            error = "❌ Invalid PAN format. Example: ABCDE1234F";
        }

        if (
            (documentType === "CPAN") &&
            !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(inputValue)
        ) {
            isValid = false;
            error = "❌ Invalid PAN format. Example: ABCDE1234F";
        }

        if (isValid) {
            onResponse(inputValue.trim()); // ✅ Send Valid Data
            setInputValue(""); // ✅ Clear Input After Submission
            setIsChatActive(false);
        } else {
            setErrorMessage(error); // ✅ Show Error
            setInputValue(""); // ✅ Clear Input
        }
    };

    // ✅ Handle Enter Key Press
    const handleKeyDown = (event) => {
        if (event.key === "Enter" && isChatActive) {
            handleSubmit(); // Submit on Enter
        }
    };

    return (
        <div className="left-chatbot-message-section">
            {isEdit && (
            <div className="input-type-text-response-title">
                {Question}          
            </div>
            )}
            <div className="input-type-text-response">
                <div className="input-type-text-response-content">
                    <div className="input-type-text-response-content-option">
                        <input
                            type="text"
                            className="custom-input"
                            value={inputValue}
                            placeholder={!isEdit ? Question : ""}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown} // Listen for Enter key
                        />
                    </div>
                    {/* ✅ Error Message (If Any) */}
                    {errorMessage && (
                        <div className="error-message" style={{ color: "red", fontSize: "12px", marginTop: "-32px", width: "450px" }}>
                            {errorMessage}
                        </div>
                    )}
                    <div className="chat-response-button" onClick={handleSubmit}>
                        <img
                            src={isChatActive ? "/images/message-send-active-icon.png" : "/images/message-send-disabled-icon.png"}
                            alt="message-send-icon"
                            style={{ cursor: isChatActive ? "pointer" : "not-allowed" }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TypedResponse;
